<template>
  <section>
    <header>
      <label>Total de {{ count }} colaboradores nesta escala</label>
    </header>
    <div class="employee-list">

      <div v-if="loading" class="loading">
        <div class="loading-item">
          <pulse-loader />
          <h5>carregando os colaboradores...</h5>
        </div>
      </div>

      <EmployeeItem
        v-else
        v-for="(employee, index) in value"
        :employee-data="employee"
        :key="employee.id"
        @updateItem="item => updateItem(item, index)"
        @clickClose="() => removeItem(index)"
      />
    </div>
  </section>
</template>

<script>
import EmployeeItem from '@/components/Employee/Item'

export default {
  components: { EmployeeItem },
  props: {
    value: Array,
    loading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    count() {
      return this.value.length
    }
  },
  methods: {
    removeItem(index) {
      const newValue = [...this.value]
      newValue.splice(index, 1)
      this.update(newValue)
    },
    update(value) {
      this.$emit('input', [...value])
    },
    updateItem({ scaleStatus, scale }, index) {
      const newValue = this.value
      newValue[index].scaleStatus = scaleStatus
      newValue[index].scale = scale
      this.update(newValue)
    }
  }
}
</script>

<style scoped>
header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

header label {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

header span {
  align-self: flex-end;
}

div.employee-list {
  overflow: auto;
  height: 532px;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
}

div.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

div.loading-item {
  display: block;
  text-align: center;
}

div.loading h5 {
  display: block;
}

div.employee-list::-webkit-scrollbar {
  width: 5px;
}

div.employee-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(70, 140, 54, 0.2);
  border-radius: 10px;
}

div.employee-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(70, 140, 54, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/List.vue